/**
 * T1 EVENTS (Agent Brains section 10, 10.1; CLAUDE.md section 5). The kinds the
 * ledger already carried on the day the catalog landed: written by shipped
 * code, with payload shapes nobody has pinned yet. Every one is registered as
 * `z.looseObject({})`, so the writer refuses an unknown kind but not yet a
 * wrong field on these.
 *
 * Each wave tightens the kinds it touches: move a kind out of this list and
 * give it a strict schema in `eventCatalog.ts`. The count pin in
 * `eventCatalog.test.ts` may only fall (`LEGACY_OPEN_KINDS_MAX`), never rise,
 * so a new kind cannot be parked here to dodge a schema. A kind that is new
 * goes in `eventCatalog.ts` strict, with its emitters.
 *
 * Tightening a kind that has a raw INSERT INTO events site: those sites
 * validate a mirrored copy of the payload today (the SQL builds its own). Once
 * the kind is strict, build the payload in JS, validate that object, and pass
 * the same object to the statement as `$n::jsonb`, so what was checked is what
 * is stored.
 *
 * `alert.<kind>` is not listed: it is a family (`ALERT_FAMILY`).
 */
export const LEGACY_OPEN_KINDS = [
  "appointment.attended",
  "appointment.booked",
  "appointment.cancelled",
  "appointment.confirmed",
  "appointment.no_show",
  "appointment.reminder_sent",
  "appointment.reminder_withheld",
  "artifact.activated",
  "bounce.recorded",
  "campaign.launch_refused",
  "campaign.template_approved",
  "campaign.template_revoked",
  "campaign.wave_sent",
  "campaign.wave_withheld",
  "complaint.closed",
  "consult.intent",
  "consult.intent.ran",
  "consult.intent.skipped",
  "contact.vip_changed",
  "digest.amber",
  "digest.weekly",
  "draft.approved",
  "draft.blocked",
  "draft.created",
  "draft.rejected",
  "draft.transmit_uncertain",
  "draft.transmitted",
  "escalation.holding_sent",
  "escalation.holding_withheld",
  "feature.suggested",
  "followup.nudge_sent",
  "followup.nudge_withheld",
  "memory.backfill_decision",
  "memory.backfill.ran",
  "memory.resolve_decision",
  "memory.save_decision",
  "memory.save_gate.ran",
  "memory.save_gate.skipped",
  "message.echoed",
  "message.received",
  "missed_call.excluded",
  "missed_call.text_back_sent",
  "missed_call.text_back_withheld",
  "notify.draft_waiting",
  "outbound.stop_cleared",
  "outbound.stopped",
  "outcome.auto_ghost",
  "outcome.ghost_reversed",
  "outcome.recorded",
  "outcome.reversed",
  "owner.note.added",
  "proposal.refused",
  "reply.blocked",
  "reply.finalize_noop",
  "reply.finalized",
  "reply.frozen",
  "reply.media_recheck",
  "reply.outage",
  "reply.skipped",
  "reply.window_blocked",
  "review.ask_claim_released",
  "review.ask_claimed",
  "review.ask_sent",
  "review.ask_withheld",
  "review.complaint_routed",
  "routing.decided",
  "send.withheld",
  "shadow.started",
  "subject.deleted",
  "thread.unfrozen",
  "transmit.done",
  "transmit.refused",
  "transmit.rejected",
  "transmit.uncertain",
] as const;

export type LegacyOpenKind = (typeof LEGACY_OPEN_KINDS)[number];
